import React from "react";
import ColumnRules from "./ColumnRules";


const ImportContractModelColumnRules = () => {
  const rules = [
    {
      name: "value",
      required: false,
      options: ["Valor."],
    },
    {
      name: "extended_value",
      required: false,
      options: ["Valor por extenso."],
    },
    {
      name: "discount",
      required: false,
      options: ["Desconto."],
    },
    {
      name: "extended_discount",
      required: false,
      options: ["Desconto por extenso."],
    },
    {
      name: "anual_value",
      required: false,
      options: ["Valor anual."],
    },
    {
      name: "extended_anual_value",
      required: false,
      options: ["Valor anual por extenso."],
    },
    {
      name: "in_cash_value",
      required: false,
      options: ["Valor a vista."],
    },
    {
      name: "extended_in_cash_value",
      required: false,
      options: ["Valor a vista por extenso."],
    },
    {
      name: "in_cash_discount_value",
      required: false,
      options: ["Desconto a vista."],
    },
    {
      name: "extended_in_cash_discount_value",
      required: false,
      options: ["Desconto a vista por extenso."],
    },
    {
      name: "installment_value",
      required: false,
      options: ["Valor da parcela."],
    },
    {
      name: "extended_installment_value",
      required: false,
      options: ["Valor da parcela por extenso."],
    },
    {
      name: "onboarding",
      required: false,
      options: ["Nome do processo de matricula."],
    },
    {
      name: "template",
      required: false,
      options: ["Modelo de contrato ou documento."],
    }
  ];

  return <ColumnRules rules={rules} />;
};

export default ImportContractModelColumnRules;
